import { render, staticRenderFns } from "./SizesEdit.vue?vue&type=template&id=73bd5d76&lang=pug"
import script from "./SizesEdit.vue?vue&type=script&lang=js"
export * from "./SizesEdit.vue?vue&type=script&lang=js"
import style0 from "./SizesEdit.vue?vue&type=style&index=0&id=73bd5d76&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports